import { Component } from '@gasman/smush';
import { NumberGrid } from './grid';

class NumberColumn extends Component {
    constructor(opts) {
        /*
        recognised opts:
        length
        property
        setter
        changeEvent
        className
        */
        super();
        this.length = opts.length || 32;
        this.property = opts.property;
        this.setter = opts.setter;
        this.changeEvent = opts.changeEvent;
        this.className = opts.className;

        this.receiver = null;
        this.undoBuffer = null;
        this.undoPath = null;

        this.grid = null;
    }

    render(container) {
        this.grid = new NumberGrid(container, {
            className: this.className,
            rows: this.length,
            columns: 1,
            getValue: (x, y) => {
                if (!this.receiver) return 0;
                return this.receiver[this.property][y];
            },
            commitValue: (x, y, val) => {
                let oldValue = this.receiver[this.property][y];
                if (oldValue == val) return;

                this.receiver[this.setter](y, val);

                if (this.undoBuffer) {
                    this.undoBuffer.push({
                        path: this.undoPath,
                        forward: { [y]: val },
                        reverse: { [y]: oldValue },
                    });
                }
            },
        });
    }

    bind(receiver, opts) {
        opts = opts || {};
        this.unbind();
        this.receiver = receiver;

        if (opts.undoBuffer) {
            this.undoBuffer = opts.undoBuffer;
            this.undoPath = [...opts.undoPath, this.property];
        }

        receiver.on(this.changeEvent, this.onChangeValue);
        if (this.grid) {
            var arr = this.receiver[this.property];
            for (let i = 0; i < this.length; i++) {
                this.grid.setValue(0, i, arr[i]);
            }
        }
    }

    unbind() {
        if (this.receiver) {
            this.receiver.removeListener(this.changeEvent, this.onChangeValue);
            this.receiver = null;
            this.undoBuffer = null;
            this.undoPath = null;
        }
    }

    onChangeValue = (i, value) => {
        this.grid.setValue(0, i, value);
    };

    static forField(field, opts) {
        return new NumberColumn({
            length: field.length,
            property: field.name,
            setter: field.setterName,
            changeEvent: field.eventName,
            ...opts,
        });
    }
}

export { NumberColumn };
